const KEYS = {
  PERSONS:      'cs_persons',
  FACILITATORS: 'cs_facilitators',
  PRAYERS:      'cs_prayers',
  USHERS:       'cs_ushers',
  YEAR:         'cs_year',
  OVERRIDES:    'cs_overrides',
};

export function loadState() {
  try {
    // If persons key is absent this is old-format data — start fresh
    const personsRaw = localStorage.getItem(KEYS.PERSONS);
    if (!personsRaw) return getDefaults();

    const persons      = JSON.parse(personsRaw);
    const facilitators = JSON.parse(localStorage.getItem(KEYS.FACILITATORS)) || [];
    const prayers      = JSON.parse(localStorage.getItem(KEYS.PRAYERS))      || [];
    const ushers       = JSON.parse(localStorage.getItem(KEYS.USHERS))       || [];
    const year         = parseInt(localStorage.getItem(KEYS.YEAR))           || new Date().getFullYear();
    const overrides    = JSON.parse(localStorage.getItem(KEYS.OVERRIDES))    || {};
    return { persons, facilitators, prayers, ushers, year, overrides };
  } catch {
    return getDefaults();
  }
}

export function saveState({ persons, facilitators, prayers, ushers, year, overrides }) {
  localStorage.setItem(KEYS.PERSONS,      JSON.stringify(persons));
  localStorage.setItem(KEYS.FACILITATORS, JSON.stringify(facilitators));
  localStorage.setItem(KEYS.PRAYERS,      JSON.stringify(prayers));
  localStorage.setItem(KEYS.USHERS,       JSON.stringify(ushers));
  localStorage.setItem(KEYS.YEAR,         String(year));
  if (overrides !== undefined)
    localStorage.setItem(KEYS.OVERRIDES, JSON.stringify(overrides));
}

export function saveOverrides(overrides) {
  localStorage.setItem(KEYS.OVERRIDES, JSON.stringify(overrides));
}

export function newId() {
  return Math.random().toString(36).slice(2);
}

// ── 기본 데이터 ─────────────────────────────────────────
function getDefaults() {
  return {
    persons: [
      { id: 'ps1', name: '홍길동' },
      { id: 'ps2', name: '김철수' },
      { id: 'ps3', name: '이영희' },
      { id: 'ps4', name: '박민준' },
      { id: 'ps5', name: '정기도' },
      { id: 'ps6', name: '한은혜' },
      { id: 'ps7', name: '강지수' },
      { id: 'ps8', name: '최동현' },
    ],
    // 역할 배정: personId 참조
    facilitators: [
      { id: 'fr1', personId: 'ps1', dayType: 'wednesday', active: true },
      { id: 'fr2', personId: 'ps2', dayType: 'wednesday', active: true },
      { id: 'fr3', personId: 'ps3', dayType: 'sunday',    active: true },
      { id: 'fr4', personId: 'ps4', dayType: 'sunday',    active: true },
    ],
    prayers: [
      { id: 'pr1', personId: 'ps5', dayType: 'wednesday',   active: true },
      { id: 'pr2', personId: 'ps6', dayType: 'wednesday',   active: true },
      { id: 'pr3', personId: 'ps3', dayType: 'sunday-9am',  active: true },
      { id: 'pr4', personId: 'ps4', dayType: 'sunday-9am',  active: true },
      { id: 'pr5', personId: 'ps7', dayType: 'sunday-noon', active: true },
      { id: 'pr6', personId: 'ps8', dayType: 'sunday-noon', active: true },
    ],
    ushers: [
      { id: 'ur1', personId: 'ps7', usherType: 'always',         active: true },
      { id: 'ur2', personId: 'ps8', usherType: 'always',         active: true },
      { id: 'ur3', personId: 'ps5', usherType: 'wednesday-only', active: true },
      { id: 'ur4', personId: 'ps6', usherType: 'wednesday-only', active: true },
    ],
    year: new Date().getFullYear(),
    overrides: {},
  };
}
